import React from "react";

const RightArrowIconcircle = () => {
 return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3249D7"/>
    <path d="M14.1328 22.4126L13 21.2649L18.0586 16.2063L13 11.1477L14.1328 10L20.3391 16.2063L14.1328 22.4126Z" fill="#3249D7"/>
    </svg>
    
);
};

export default RightArrowIconcircle
